import type { Transport, Client } from '@connectrpc/connect';
import { createClient } from '@connectrpc/connect';
import { createConnectTransport, createGrpcWebTransport } from '@connectrpc/connect-web';
import { QueryService } from '@kentik/schema/gen/ts/kentik/query/v20251204alpha1/query_pb';
import { Health } from '@kentik/schema/gen/ts/grpc/health/v1/health_pb';

let _grpcTransport: Transport;

interface ClientMap {
  Health: Client<typeof Health>;
  QueryService: Client<typeof QueryService>;
}

let _clients: ClientMap | null = null;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function initializeGrpcTransport($auth: any, type: 'json' | 'grpc-web' = 'json') {
  if (type === 'grpc-web') {
    _grpcTransport = createGrpcWebTransport({
      baseUrl: '/',
      useBinaryFormat: false,
      interceptors: [
        (next) => (req) => {
          req.header.set('X-CSRF-Token', $auth.csrfToken);
          return next(req);
        }
      ]
    });
  } else {
    _grpcTransport = createConnectTransport({
      baseUrl: '/',
      interceptors: [
        (next) => (req) => {
          req.header.set('X-CSRF-Token', $auth.csrfToken);
          return next(req);
        }
      ]
    });
  }

  _clients = {
    Health: createClient(Health, _grpcTransport),
    QueryService: createClient(QueryService, _grpcTransport)
  };
}

export function getClient<K extends keyof ClientMap>(name: K): ClientMap[K] {
  if (!_grpcTransport) {
    throw new Error('GRPC transport not initialized, call initializeGrpcTransport() first');
  }
  if (!_clients || !_clients[name]) {
    throw new Error(`Unable to find GRPC service client: ${name}`);
  }
  return _clients[name];
}
